import { ApiBitMask, ApiBitMaskTypes } from '../../../logger/bitMasks/ApiBitMask';
import { Fetcher } from '../../Fetcher';

import { tableConfigParser } from './parser';
import type { IServerTableConfigResponse, ITableConfigParserOptions, TableConfigType } from './types';

export interface IFetchTableConfigParams {
  baseUrl: string;
  parserOptions: ITableConfigParserOptions;
  params: any;
}

interface TableConfigPayload {
  parsedResponse: TableConfigType;
  rawResponse: IServerTableConfigResponse;
}

export const fetchTableConfig = ({
  baseUrl,
  params,
  parserOptions,
}: IFetchTableConfigParams): Promise<TableConfigPayload> => {
  const url = `${baseUrl}/api/ui/tableConfig`;

  return Fetcher.fetch<IServerTableConfigResponse | { errorCode: string | number; description: string }>(url, {
    params,
  })
    .then((response) => {
      if ('description' in response || 'errorCode' in response) {
        throw new Error(response.description || response.errorCode.toString());
      }

      const parsedResponse = tableConfigParser({
        response: response,
        parseBetLimits: parserOptions.parseBetLimits,
        parsePayouts: parserOptions.parsePayouts,
      });

      const overrideProperties = parserOptions.overrideProperties ?? {};

      return { parsedResponse: { ...parsedResponse, ...overrideProperties }, rawResponse: response };
    })
    .then((response) => {
      ApiBitMask.apply(ApiBitMaskTypes.TableConfig);
      return response;
    });
};
